import React from "react";
import { Link } from "react-router-dom";
import banner from "./assets/banner.jpg";
import "./Home.css";
import { esAdmin as esAdminCuenta, esCobros } from "./roles";

function Home({ usuario }) {
  const esAdmin = esAdminCuenta(usuario);
  const esCuentaCobros = esCobros(usuario);
  const mostrarNombre =
    usuario?.nombre && usuario?.apellido
      ? `${usuario.nombre} ${usuario.apellido}`
      : usuario?.email;

  // ===== HOME COBROS: foco en Pagos =====
  if (usuario && esCuentaCobros) {
    return (
      <div className="home-container fade-in">
        <section className="admin-hero">
          <h1 className="admin-title">Bienvenido, {mostrarNombre}</h1>
          <p className="admin-subtitle">
            Accedé al panel para registrar y controlar los pagos.
          </p>
          <Link to="/admin" className="btn-admin-big">
            Ir a Pagos
          </Link>
        </section>
      </div>
    );
  }

  // ===== HOME ADMIN: foco en Panel =====
  if (usuario && esAdmin) {
    return (
      <div className="home-container fade-in">
        {/* Hero admin: CTA principal */}
        <section className="admin-hero">
          <h1 className="admin-title">Bienvenido, {mostrarNombre}</h1>
          <p className="admin-subtitle">
            Accedé al panel para gestionar reservas, pagos, usuarios, precios y más.
          </p>
          <Link to="/admin" className="btn-admin-big">
            Ir al Panel de Administración
          </Link>
        </section>

        {/* Accesos rápidos secundarios */}
        <section className="admin-quick">
          <h3 className="admin-quick-title">Accesos rápidos</h3>
          <div className="admin-quick-grid">
            <Link to="/reservas" className="chip-link">🏠 Casas</Link>
            <Link to="/camping"  className="chip-link">⛺ Camping</Link>
            <Link to="/dia"      className="chip-link">🌞 Día</Link>
            <Link to="/info"     className="chip-link">ℹ️ Info útil</Link>
          </div>
        </section>
      </div>
    );
  }

  // ===== HOME USUARIO (tu versión actual) =====
  return (
    <div className="home-container fade-in">
      {/* HERO compacto */}
      <section className="home-hero">
        <img src={banner} alt="Cuchilla Alta" className="home-hero-img" />
        <div className="home-hero-text">
          <h1 className="home-title">Bienvenido a Cuchilla Alta</h1>
          <div className="home-subtitle">
            {usuario ? (
              <>
                <p>Hola, <b>{mostrarNombre}</b>.</p>
                <p>Este es el Sistema de Reservas del Parque de Retiros Mennonita de Cuchilla Alta.</p>
              </>
            ) : (
              <>
                <p>Este es el Sistema de Reservas del Parque de Retiros Mennonita de Cuchilla Alta.</p>
              </>
            )}
          </div>
        </div>
      </section>

      {usuario ? (
        <>
          {/* 3 opciones principales */}
          <section className="home-grid">
            <Link to="/reservas" className="home-option">
              <div className="icon" aria-hidden>🏠</div>
              <h3>Reservar <span>CASA</span></h3>
              <p>Elegí fechas y una de las casas disponibles.</p>
              <span className="cta">Ir a Casas</span>
            </Link>

            <Link to="/camping" className="home-option">
              <div className="icon" aria-hidden>⛺️</div>
              <h3>Registrar estadía <span>CAMPING</span></h3>
              <p>Indicá personas y noches. Pago se confirma luego.</p>
              <span className="cta">Ir a Camping</span>
            </Link>

            <Link to="/dia" className="home-option">
              <div className="icon" aria-hidden>🌞</div>
              <h3>Registrar estadía por el <span>DÍA</span></h3>
              <p>Si te quedás por el día, registralo acá.</p>
              <span className="cta">Ir a “Por el día”</span>
            </Link>
          </section>

          {/* Acciones secundarias */}
          <section className="home-secondary">
            <Link to="/reservas#misreservas" className="btn-secondary">
              Mis Reservas de Casas
            </Link>
            <Link to="/info" className="btn-secondary">
              Info Útil
            </Link>
          </section>
        </>
      ) : (
        // Si no hay usuario: CTA a iniciar sesión
        <div className="home-card">
          <Link to="/login" className="boton-principal">
            Iniciar Sesión
          </Link>
        </div>
      )}
    </div>
  );
}

export default Home;
